import Vue from 'vue';
import RocketApi from '../../model/chat/chatapi.js';
import { requestHandler } from '../../model/chat/chat-request-handler.js';

import { appStartTime } from '../../model/app-start-time.js';

let chatApi = null;

export default {
	namespaced: true,
	state: {
		connectedToApi: true,
        loggedIn: false,
        userId: '',
        authToken: '',
        userRooms: [],
        newMessage: '',
        messages: [],
        errors: [],
        login: 'admin',
        password: 'Sml103mm',
        currentRoomId: '',
        currentRoomName:'',
        currentLiveRoomId:'',
        restUserId: '',
        restAuthToken: '',
        userInfo: {},
        userAvatar:'',
        defaultAvatar:false,
        countUsers:[],
        roomsForRobots:['GxPdourxnLZTn8bS3','SzTxmGjZ3Ls7meHip','quNyJDfKMLbtD2Cpd','qnyBnbnoXAphn9Tyq','oYDdSLr8Ko4cjkAqR','rxJCXtWfTWM2DxSWD','FyHkn552jTt392MjM','GgaShiX8ebRZxT5j4']
	},
	getters: {
		getChatApiUri(state, getters, rootState, rootGetters) {
			return rootGetters['api/getChatApiUri'];
		},
		getChatRestUri(state, getters, rootState, rootGetters) {
			return rootGetters['api/getChatRestUri'];
		},
		getRequestProxyUri(state, getters, rootState, rootGetters) {
			return rootGetters['api/getRequestProxyUri'];
		},
		login(state) {
			return state.login;
		},
		password(state) {
			return state.password;
		},
		loggedIn(state) {
			return state.loggedIn;
		},
		authToken(state) {
			return state.authToken;
		},
		userRooms(state) {
			return state.userRooms;
		},
		messages(state) {
			return state.messages;
		},
		errors(state) {
			return state.errors;
		},
		currentRoomId(state) {
			return state.currentRoomId;
        },
        currentRoomName(state) {
			return state.currentRoomName;
        },
		restUserId(state) {
			return state.restUserId;
		},
		restAuthToken(state) {
			return state.restAuthToken;
		},
		userInfo(state) {
			return state.userInfo;
        },
        getAvatarUrl(state) {
            return state.userAvatar;
        },
        getSatusAvatar(state) {
            return state.defaultAvatar;
        },
        getUsersInRoom(state) {
            return state.countUsers;
        },
        getRoomsForRobots(state) {
            return state.roomsForRobots;
        },
	},
	mutations: {
		setLoggedIn(state, logIn) {
			state.loggedIn = logIn;
		},
		saveMessage(state, msg) {
			state.messages.push(msg);
		},
		saveError(state, err) {
			state.errors.push(err);
		},
		setCredentials(state, payload) {
			state.login = payload.login;
			state.password = payload.password;
		},
		setUserRooms(state, rooms) {
			state.userRooms = rooms;
		},
		setCurrentRoomId(state, roomId) {
			state.currentRoomId = roomId;
        },
        setCurrentRoomName(state, roomName) {
			state.currentRoomName= roomName;
        },
		setRestUserInfo(state, inf) {
			state.restUserId = inf.userId;
			state.restAuthToken = inf.authToken;
			state.userInfo = inf.me;
        },
        setAvatar(state, url) {
            state.userAvatar = url
        },
        setSatusAvatar(state, status) {
            state.defaultAvatar = status
        },
        setMessageStatus(state, info) {
            if (state.currentRoomId !== info.roomId) {
                for(let i = 0; i < state.countUsers.length; i++) {
                    if(state.countUsers[i].idRoom === info.roomId) {
                        state.countUsers[i].newMessages= info.status;
                        state.countUsers[i].cntUnreadMsg+=1
                    }
                }
            }
        },
        setReadStatus(state, roomId) {
                for(let i = 0; i < state.countUsers.length; i++) {
                    if(state.countUsers[i].idRoom === roomId) {
                        state.countUsers[i].newMessages= false;
                        state.countUsers[i].cntUnreadMsg = 0;
                    }
                }
        },
        setUserCount(state, dataRoom) {
            state.countUsers.push({
                idRoom: dataRoom.room._id,
                cnt:dataRoom.room.usersCount,
                cntUnreadMsg:0,
                type:dataRoom.room.t,
                lastMessage:dataRoom.room.lm,
                newMessages:new Date(appStartTime.getLastTime()).getTime() < new Date(dataRoom.room.lm).getTime() ? true : false,
            });
        },
	},
	actions: {
		connect(state)  {
			let uri = state.getters.getChatApiUri;
			chatApi = RocketApi.connectToRocketChat(uri);
            requestHandler.api = chatApi;
			chatApi.onError(error => state.commit('saveError', error));
			chatApi.onCompletion(() => console.log("chat is finished"));
			chatApi.onMessage(message => {
                //console.log(message)
                state.commit('saveMessage', message);
				try {
					let parsedMsg = message === null ? null :
                        (typeof message === 'string' || message instanceof String) ? JSON.parse(message) : message;
					onChannelMessage(state, parsedMsg);
				} catch (e) {
					console.log('cannot parse');
				}
			});
			chatApi.connectToServer().subscribe(() => {
					chatApi.keepAlive();
				},
				(error) => {
					state.commit('saveError', error);
                });
            chatApi.sendMessage({
                "msg": "sub",
                "id": '' + new Date().getTime(),
                "name": "stream-room-messages",
                "params": [
                    '__my_messages__',
                    false
                ]
            });					
		},
		login(state) {
	        if (state.getters.loggedIn) return; 
	        //console.log(chatApi);
			chatApi.login(state.getters.login, state.getters.password).subscribe(apiEvent => {
					if (apiEvent.msg === 'result') {
						// success
						state.commit('saveMessage', apiEvent.msg);
						state.commit('setLoggedIn', true);
                        onSuccessfulLogin(state);
	              	}
	            }, (error) => {
	            	state.commit('saveError', error);
	            });
	    },
	    loginRest(store) {   	
	    	let query = {
				method: 'POST',
				url: store.getters.getChatRestUri + 'login',
				data: `user=${store.getters.login}&password=${store.getters.password}`,
				headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
				},
				json: true
            };
	    	Vue.axios(query).then(response => {
			    if (response.data && response.data.data) {
                    store.commit('setRestUserInfo', response.data.data);
                    store.dispatch('refreshAvatar');
                    delayRequest(store,store.getters.userRooms.length - 1,200);
                }
			}, response => {
				console.log('Error logging in (REST)');
			});
        },
        createDirectRoom(state, userLogin) {
            let query = {
				method: 'POST',
				url: state.getters.getChatRestUri + 'channels.create',
                data: `name=123&members:[${userLogin}],${state.getters.login}]&readOnly:false`,
				headers: {
                    'X-Auth-Token': state.getters.restAuthToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-User-Id': state.getters.restUserId
				},
				json: true
            };
            Vue.axios(query).then(response => {
                //console.log(response.data);
            },
                response => {
                    //console.log('Error logging in (REST)');
                    //console.log(response);
                }
                );
        },
        uploadAvatar(state, file) {
            let formData = new FormData();
            formData.append('image', file);
            let query = {
				method: 'POST',
				url: state.getters.getChatRestUri + 'users.setAvatar',
				headers: {
                    'X-Auth-Token': state.getters.restAuthToken,
                    'Content-Type': 'multipart/form-data',
                    'X-User-Id': state.getters.restUserId
                },
                data:formData
            };
            Vue.axios(query).then(response => {
                state.dispatch('refreshAvatar')
                //state.dispatch('getAvatar');
                //console.log(response);
            },
                response => {
                    console.log('Error logging in (REST)');
                    //console.log(response);
                }
                );
        },
        resetAvatar(store) {
            let query = {
				method: 'POST',
				url: store.getters.getChatRestUri + 'users.resetAvatar',
				headers: {
                    'X-Auth-Token': store.getters.restAuthToken,
                    'Content-Type': 'application/json',
                    'X-User-Id': store.getters.restUserId
                },
                data:{userId: store.getters.restUserId},
                json: true
            };
            Vue.axios(query).then(response => {
                store.dispatch('refreshAvatar');
                //console.log(response);
            },
                response => {
                    //console.log('Error logging in (REST)');
                    //console.log(response);
                }
                );
        },
        getAvatar(store) {
            let query = {
                method: 'GET',
                responseType: 'arraybuffer',
                headers: {
                },
				url: store.getters.getChatRestUri + 'users.getAvatar?userId='+store.getters.restUserId,
			};
	    	Vue.axios(query).then(response => {
                
			    store.commit('setAvatar', new Buffer(response.data, 'binary').toString('base64'));
			}, response => {
				console.log('Error logging in (REST)');
				
			});
        },
        refreshAvatar(store) {
            let query = {
                method: 'GET',
                'Cache-Control': 'no-cache',
                responseType: 'arraybuffer',
                //'If-Modified-Since': new Date(),
				url: 'https://chat.iqquantum.com/avatar/' + store.getters.userInfo.username + '?dc_'+new Date().getMilliseconds(),
			};
	    	Vue.axios(query).then(response => {
                if(response.headers['content-type'] === 'image/svg+xml') {
                    store.commit('setAvatar',response.config.url);
                    store.commit('setSatusAvatar', true);
                }
                else {
                    store.commit('setAvatar','data:text/html;base64,' + new Buffer(response.data, 'binary').toString('base64'));
                    store.commit('setSatusAvatar', false);
                }
			}, response => {
				
			});
        },
        getCountUsersInRoom(store,roomId) {
            if(roomId === undefined)
                return
            let query = {
                method: 'GET',
                url: store.getters.getChatRestUri + 'rooms.info?roomId=' + roomId,
                headers: {
                    'X-Auth-Token': store.getters.restAuthToken,
                    'Content-Type': 'application/json',
                    'X-User-Id': store.getters.restUserId
                },
                    json: true
            };
            Vue.axios(query).then(response => {
                store.commit('setUserCount', response.data);
            })
        },
	    logout(state) {
	        if (!state.getters.loggedIn) return; 
			chatApi.sendMessage({
				"msg": "method",
				"name": "logout",
				"id": '' + new Date().getTime(),
				"params": []
			});
			state.commit('setLoggedIn', false);
	    },
	    connectWithCreds(state, creds) {
	        if (state.getters.loggedIn) return; 
	        state.commit('setCredentials', creds);
			state.dispatch('connect');
	    },
	    listChannels(state) {
	    	if (!state.getters.loggedIn) return; 	    	
	    	let query = {
				method: 'GET',
				uri: state.getters.getChatRestUri + 'channels.list',
				headers: {
					'X-Auth-Token': state.getters.restAuthToken,
					'X-User-Id': state.getters.restUserId
				}
			};
			
			let proxyQuery = {
				url: state.getters.getRequestProxyUri + 'Proxy/query',
				method: 'POST',
				data: JSON.stringify(query),
				headers: {
					'Content-Type': 'application/json'
				}
			};
	    	Vue.axios(proxyQuery).then(response => {
	    		if (!response) {
	    			console.log('querying channels: no response');
	    			return;
	    		}
	    		if (!response.data) {
	    			console.log('querying channels: no meaningful response');
	    			return;
	    		}
	    		if (!response.data.succeed) {
	    			console.log(`failed to query channels: ${response.data}`);
	    			return;
	    		}
			    console.log(response.data.data);
			}, response => {
				console.log('Error listing channels');
				//console.log(response);
			});
	    },
	    queryRooms(state) {
	    	let datePtr = { };
	    	datePtr['$date'] = 0; // 1480377601; //Math.floor(new Date().getTime());
	    	requestHandler.request({
	    		msg: 'method',
			    method: 'rooms/get',
			    params: [ 
			    	datePtr // last time called
			    ]
	    	}, (result) => {
	    		if (!result || !result.update) return;
                state.commit('setUserRooms', result.update);
                state.dispatch('loginRest');
	    	});
	    },
        enterRoom(state, roomId) {
            state.commit('setCurrentRoomId', roomId);
            if(state.userRooms === [])
                return
			chatApi.sendMessage({
				"msg": "sub",
				"id": '' + new Date().getTime(),
				"name": "stream-room-messages",
				"params": [
					roomId,
					false
				]
			});
			//console.log(`loadRoomHistory for room ${state.getters.currentRoomId}`);
			state.dispatch('loadRoomHistory');
          },
        enterDirectRoom(state, userId) {
            requestHandler.request({
                msg: "method",
                method: "createDirectMessage",
				params: [ userId
				]
			},(result) => {
                if (!result || !result.rid) return;
                state.commit('setCurrentRoomId', result.rid);
                state.dispatch('loadRoomHistory');
            });
            chatApi.sendMessage({
				"msg": "sub",
				"id": '' + new Date().getTime(),
				"name": "stream-room-messages",
				"params": [
					'__my_messages__',
					false
				]
			});
        },
      	loadRoomHistory(state, msgCount) {
	    	if (!msgCount) msgCount = 50;
	    	let startTime = new Date();
	    	startTime.setDate(startTime.getDate() - 30);
	    	requestHandler.request({
	    		msg: 'method',
			    method: 'loadHistory',
			    params: [ 
			    	state.getters.currentRoomId,
			    	null,
			    	msgCount,
			    	{ $date: startTime.getTime() }
			    ]
	    	}, (result) => {
	    		// result.firstUnread, result.messages: []
	    		if (!result || !result.messages) return;
	    		state.dispatch('chatmessage/reloadRoomMessages', result.messages, { root: true });
	    	});
	    },
	    // payload { msg, roomId }
      	sendChatMessage(state, payload) {
      		if (!state.getters.loggedIn) return;
      		let roomId = payload.roomId;
      		let msg = payload.msg;
      		//console.log(`sending ${msg} to ${roomId}`);
      		if (!msg || !msg.length) return;
      		if (!roomId || !roomId.length)
      			roomId = state.getters.currentRoomId;
      		if (!roomId || !roomId.length) {
      			//console.log('Enter the room before sending a message');
      			return;
      		}
			chatApi.sendMessage ({
				"msg": "method",
				"method": "sendMessage",
				"id": '' + new Date().getTime(),
				"params": [
					{
						"_id": '' + new Date().getTime(),
						"rid": roomId,
						"msg": msg
					}
				]
            });
        },
	}
}

function onSuccessfulLogin(state) {
	state.dispatch('queryRooms');
}

function onChannelMessage(state, msg) {
	if (msg.msg === 'result') {
		requestHandler.onResponse(msg);
		return;
	}
	if (msg.msg === 'connected') {
		onMsgConnected(state, msg);
		return;
	}
	if (msg.msg === 'added' && msg.collection === 'users') {
		onUserLoggedIn(state, msg);
		return;
	}
	if (msg.msg === 'changed' && msg.collection === 'stream-room-messages' && msg.fields && msg.fields.args) {
        onNewMessages(state, msg.fields.args);
        return;
    }
        
}

function onUserLoggedIn(state, msg) {
	//chatApi.session = msg.session;
}

function onMsgConnected(state, msg) {
	//chatApi.userId = msg.id;
	state.dispatch('login');
}

function onNewMessages(state, messages) {
    state.commit('setMessageStatus', {roomId:messages[0].rid, status:true});
	state.dispatch('chatmessage/storeMessages', messages, { root: true });
}

function delayRequest (store, count, interval) {
    setTimeout(() => {
        if (count > 0 || count === 0) {
            let p = store.getters.userRooms;
            store.dispatch('getCountUsersInRoom',p[count]._id)
            delayRequest(store, count - 1, interval)
        }
      }, interval)
}

export function formatChatMessage(message) {
	let result = { message: message };
	if (message.fields && message.fields.args &&
		message.fields.args.length && message.fields.args[0].ts &&
		message.fields.args[0].ts.$date)
		result.date = new Date(message.fields.args[0].ts.$date);
	return result;
}